import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { docMoveWsEvent } from '../docMoveActionCreators';
import type { TopicHandler } from './types';

export const handleMvDocMove: TopicHandler = (_state, event) => {
    if (event.message?.includes('subscribe')) return null;
    const whitelist = ['docMoveEventInitiated', 'docMoveEventSuccess', 'docMoveEventFailure'];
    if (!whitelist.includes(event.data?._type)) return null;

    logNewRelicPageAction('MV:DocMove:WebSocketReceived', {
        correlationId: event.data.traceId,
        eventType: event.data._type,
        eventTimestamp: event.data.timestamp,
        receivedTimestamp: new Date().toISOString(),
        wsToRenderDelayMs: event.data.timestamp ? Date.now() - new Date(event.data.timestamp).getTime() : null
    });
    return docMoveWsEvent(event);
};
